jQuery(document).ready(function ($) {
    function enableFormSubmitButton(event) {
        console.log(`${event.type}: enable`);

        if ($(this).find('.wpcf7-submit').attr('disabled') === 'disabled') {
            $(this).find('.wpcf7-submit').removeAttr('disabled');
        }
    }

    function disableFormSubmitButton(event) {
        console.log(`${event.type}: disable`);
        $(this).find('.wpcf7-submit').attr('disabled', '');
    }

    $(document).on({
        'change wpcf7statuschanged': enableFormSubmitButton,
        'submit': disableFormSubmitButton,
    }, '.wpcf7-form')

    // Flag empty date fields so the CSS can hide the browser's "dd/mm/yyyy" mask until the field is used
    function flagEmptyDates() {
        $('.wpcf7-form input[type="date"]').each(function () {
            $(this).toggleClass('is-empty', !this.value);
        });
    }

    flagEmptyDates();

    $(document).on('input change wpcf7reset', flagEmptyDates);

    $(document).on('click', '.wpcf7-response-output', function () {
        $(this).fadeOut();
    });
});